export default __webpack_public_path__ + "static/media/divider_bg.0a4dc4ac.jpeg";